module.exports = [
    {
        "orderName": "Deluxe Collaborative 1 Advisor",
        "orderId": "12427876",
        "idProgram": "MAIN",
        "product": "BusCard",
        "programName": "Main",
        "programType": null,
        "idCart": null,
        "branchName": "Engel \u0026 V\u00f6lkers East Greenwich",
        "idBranch": "b6e4138947",
        "agentNameFirst": "Kerri",
        "agentNameLast": "Giroux",
        "idAgent": "c2fd97fbcc",
        "date": {"date": "2022-03-03 09:48:29.000000", "timezone_type": 3, "timezone": "America\/Chicago"},
        "addressable": "",
        "idEvent": null,
        "idProductType": 3,
        "legacyOrder": false,
        "proofEngineType": 7,
        "photoCount": 0
    },
];

